import { clsx } from 'clsx';
import { ReactComponent as DagensLogo } from './logo.svg';

export const Logo = () => {
  return <DagensLogo className={clsx('w-[64px]')} />;
};
